import React from 'react';

import { Link } from '../arkulpa-fec/components/FormElements';
import {mapUserToRecipient} from '../helpers/mailHelper';
import EntityTable from '../arkulpa-fec/components/EntityTable';
import LoadingIndicator from '../arkulpa-fec/components/LoadingIndicator';

const _tableConfig = maxRows => {
  return {
    maxRows,
    cols: [
      {
        header: 'Name',
        valueKey: '*',
        method: ({firstName, lastName}) => lastName + ' ' + firstName,
        width: '25%'
      },
      {
        header: 'Email',
        valueKey: '*',
        method: user => (
          <span onClick={e => e.stopPropagation()}>
            <Link href={'mailto:' + mapUserToRecipient(user)}>{user.email}</Link>
          </span>
        ),
        width: '25%'
      },
      {
        header: 'Telefonnummer',
        valueKey: 'phone',
        method: phone => phone,
        width: '25%'
      },
      {
        header: 'Rolle',
        valueKey: 'role',
        method: role => role,
        width: '15%'
      },
    ]
  };
};

export default ({loading, users, history, maxRows = 30}) => (
  <div>
    <EntityTable
      tableConfig={_tableConfig(maxRows)}
      data={loading ? [] : users}
      msg={'Noch keine Benutzer erstellt'}
      onRowClicked={row => history.push('/user/' + row._id)}
    />
    {loading && <LoadingIndicator />}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/UserList.js